import { type ResponsiveProps } from 'react-grid-layout';

import type { GetDashboardResponse, GetExecutionResponse } from '@blockworks/platform/api/research/studio';

const ROW_HEIGHT = 10;
const RESIZE_HANDLES: ResponsiveProps['resizeHandles'] = ['se', 'sw'];
/** A CSS selector for tags that will not be draggable. */
const DRAGGABLE_CANCEL_CLASS = 'bw-grid-item-draggable-cancel';
const DRAGGABLE_CANCEL = `.${DRAGGABLE_CANCEL_CLASS}`;

type PreloadedDashboardData = (GetDashboardResponse['data']['visualizations'][number] & {
    execution: GetExecutionResponse['data'];
})[];

enum DashboardMode {
    Dynamic = 'dynamic',
    Preloaded = 'preloaded',
}

export type { PreloadedDashboardData };
export { DashboardMode, DRAGGABLE_CANCEL, DRAGGABLE_CANCEL_CLASS, RESIZE_HANDLES, ROW_HEIGHT };
